import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-label" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "p-required" }, "*", -1)
const _hoisted_3 = { class: "grid" }
const _hoisted_4 = { class: "md:col-6" }
const _hoisted_5 = { class: "md:col-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _cache[3] || (_cache[3] = _withModifiers(($event: any) => ($setup.handleSubmit(!$setup.v$.$invalid)), ["prevent"])),
    class: "_form"
  }, [
    _createElementVNode("label", {
      class: _normalizeClass(["p-field mb-4", { 'p-invalid': $setup.v$.vin.$invalid && $setup.v$.vin.$dirty }])
    }, [
      _createElementVNode("span", _hoisted_1, [
        _createElementVNode("span", null, _toDisplayString(_ctx.$t('vehicles_page.vin')), 1),
        _hoisted_2
      ]),
      _createVNode(_component_InputText, {
        type: "text",
        modelValue: $setup.v$.vin.$model,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.v$.vin.$model) = $event)),
        onBlur: _cache[1] || (_cache[1] = ($event: any) => ($setup.v$.vin.$touch()))
      }, null, 8, ["modelValue"])
    ], 2),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_Button, {
          class: "p-button-big _full-width",
          type: "button",
          onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.handleSubmit(!$setup.v$.$invalid, true))),
          disabled: $setup.submiting
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('vehicles_page.add_vehicle')), 1)
          ]),
          _: 1
        }, 8, ["disabled"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_Button, {
          class: "p-button-big p-button-outlined p-button-primary _full-width",
          type: "submit",
          disabled: $setup.submiting
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('vehicles_page.add_vehicle_more')), 1)
          ]),
          _: 1
        }, 8, ["disabled"])
      ])
    ])
  ], 32))
}